import { Skeleton, Stack } from '@mui/material';

import { useWaiverRecord } from '@/apps/engagement-letter-database/store/useWaiverRecord';
import { useBreadcrumb } from '@/shared/components/Breadcrumbs';

import HeaderPane from './components/HeaderPane';
import SearchResults from './components/SearchResults';
import SysInfoPane from './components/SysInfoPane';
import WaiverInfoPane from './components/WaiverInfoPane';

const WaiverRecordsDashboard = () => {
  const { record: waiverRecord, isLoading } = useWaiverRecord();

  useBreadcrumb({
    label: waiverRecord?.clientName || waiverRecord?.adverseClientName || 'Waiver Record',
    hideIntermediateSegments: true,
  });

  if (isLoading || !waiverRecord) {
    return (
      <Stack spacing={2}>
        <Skeleton variant="rectangular" height={120} />
        <Skeleton variant="rectangular" height={300} />
      </Stack>
    );
  }

  const sysInfoRecord = {
    createdBy: (waiverRecord.createdByUser?.displayName ?? waiverRecord.createdBy) || 'N/A',
    createdDate: waiverRecord.createdAt?.toISOString() ?? 'N/A',
    modifiedBy: (waiverRecord.updatedByUser?.displayName ?? waiverRecord.updatedBy) || 'N/A',
    modifiedDate: waiverRecord.updatedAt?.toISOString() ?? 'N/A',
  };

  return (
    <>
      <HeaderPane record={waiverRecord} />
      <WaiverInfoPane record={waiverRecord} />
      <SearchResults record={waiverRecord} />
      <SysInfoPane record={sysInfoRecord} />
    </>
  );
};

export default WaiverRecordsDashboard;
